import { render } from "./SyncDataConfirmModal.vue?vue&type=template&id=220bd779"
import script from "./SyncDataConfirmModal.vue?vue&type=script&lang=js"
export * from "./SyncDataConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__